import { render, staticRenderFns } from "./AddressInfoBlock.vue?vue&type=template&id=71abb50b&scoped=true&"
import script from "./AddressInfoBlock.vue?vue&type=script&lang=js&"
export * from "./AddressInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71abb50b",
  null
  
)

export default component.exports